import React from "react";
import CommentsFieldProto from "./comments-proto";

export default function renderCommentsInView(props) {
    return <CommentsFieldProto renderMode="view" {...props} />;
}